import React, { useState } from 'react'
import { useForm } from "react-hook-form"
import { Link } from "react-router-dom"
import { toAbsoluteUrl } from "../helpers"
import passwordResetService from "../../services/passwordReset.service"

function ForgotPassword() {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm()

    const [message, setMessage] = useState(null)
    const [messageType, setMessageType] = useState('danger')
    const [isSuccess, setIsSuccess] = useState(false)

    const onSubmit = async (data) => {
        setMessage(null)
        try {
            await passwordResetService.requestPasswordReset(data.username)
            setIsSuccess(true)
            setMessage("If an account exists with this username, you will receive a password reset link shortly.")
            setMessageType('success')
        } catch (error) {
            console.error(error)
            if (error.response?.status === 429) {
                setMessage("Too many requests. Please wait a few minutes before trying again.")
            } else if (error.response?.data?.error) {
                setMessage(error.response.data.error)
            } else {
                setMessage("Something went wrong. Please try again later.")
            }
            setMessageType('danger')
        }
    }

    if (isSuccess) {
        return (
            <div className="h-100 d-flex align-items-center justify-content-center py-5 min-vh-90">
                <div className="card shadow-lg w-100 w-md-500px">
                    <div className="card-body p-10 p-lg-15">
                        <div className="text-center mb-10">
                            <img
                                src={toAbsoluteUrl('media/logos/eyeconx-logo.png')}
                                alt="Eyeconx Logo"
                                className="h-50px mb-5"
                                height={"50px"}
                            />
                            <h1 className="text-dark fw-bolder mb-3">Check Your Email</h1>
                        </div>

                        <div className="alert alert-success d-flex align-items-center p-5 mb-10" role="alert">
                            <i className="bi bi-envelope-check-fill me-3 fs-3" aria-hidden="true"></i>
                            <div>
                                <p className="mb-1">{message}</p>
                                <p className="mb-0 text-muted small">Please check your inbox and spam folder.</p>
                            </div>
                        </div>

                        <div className="text-center">
                            <Link to="/login" className="btn btn-primary text-white">
                                Back to Login
                            </Link>
                        </div>

                        <div className="text-center mt-5">
                            <span className="text-gray-600 fs-6 fw-semibold">
                                Didn't receive the email?{' '}
                                <button
                                    type="button"
                                    className="btn btn-link p-0 link-primary text-decoration-none fw-semibold"
                                    onClick={() => setIsSuccess(false)}
                                >
                                    Try again
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="h-100 d-flex align-items-center justify-content-center py-5 min-vh-90">
            <div className="card shadow-lg w-100 w-md-500px">
                <div className="card-body p-10 p-lg-15">
                    <div className="text-center mb-10">
                        <img
                            src={toAbsoluteUrl('media/logos/eyeconx-logo.png')}
                            alt="Eyeconx Logo"
                            className="h-50px mb-5"
                            height={"50px"}
                        />
                        <h1 className="text-dark fw-bolder mb-3">Forgot Password?</h1>
                        <div className="text-gray-500 fw-semibold fs-6">
                            Enter your username to reset your password
                        </div>
                    </div>

                    {message && (
                        <div className={`alert alert-${messageType} d-flex align-items-center p-5 mb-10`} role="alert">
                            <i className={`bi ${messageType === 'danger' ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'} me-3 fs-3`} aria-hidden="true"></i>
                            <div className="flex-grow-1">{message}</div>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setMessage(null)}
                                aria-label="Close alert"
                            ></button>
                        </div>
                    )}

                    <form className="form w-100" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className="fv-row mb-8">
                            <label htmlFor="username" className="form-label fs-6 fw-bolder text-dark">Username</label>
                            <input
                                type="text"
                                id="username"
                                className={`form-control form-control-lg form-control-solid ${errors.username ? 'is-invalid' : ''}`}
                                placeholder="Enter your username"
                                {...register("username", { required: "Username is required" })}
                            />
                            {errors.username && (
                                <div className="invalid-feedback">{errors.username.message}</div>
                            )}
                        </div>

                        <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                            <button
                                type="submit"
                                className="btn btn-primary me-4 px-6 py-3 text-white"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <span className="d-flex align-items-center">
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Sending...
                                    </span>
                                ) : (
                                    'Send Reset Link'
                                )}
                            </button>
                            <Link to="/login" className="btn btn-light px-6 py-3">
                                Cancel
                            </Link>
                        </div>
                    </form>

                    <div className="text-center mt-5">
                        <span className="text-gray-600 fs-6 fw-semibold">
                            Remember your password?{' '}
                            <Link to="/login" className="link-primary text-decoration-none">
                                Sign in
                            </Link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword